import { createInitializerQueueList } from './initializer-manager';
import { EnvironmentProviders } from '@angular/core';
import { DataPreloaderService } from '../services/data-preloader.service';
import { UserService } from '../services/user/user.service';
import { PwaService } from '../services/pwa.service';
import { GlobalEventsService } from '../services/global-events.service';
import { FullScreenService } from '../services/full-screen.service';
import { RedirectorService } from '../services/redirector.service';
import { ContentUpdaterService } from '../services/content-updater/content-updater.service';
import { GameProvidersService } from '../services/games/game-providers.service';
import { GameCategoryAttrService } from '../services/games/game-category-attribute.service';
import { BankingService } from '../services/banking.service';
import { ZendeskChatService } from '../services/zendesk/zendesk-chat.service';
import { SeoService } from '../services/seo.service';
import { EpmCountryRestrictionService } from '../services/epm-country-restriction.service';
import { GoogleTagManagerService } from '../services/google-tag-manager.service';
import { UserRestrictionsService } from '../services/user/user-restrictions.service';
import { ServerSentEventsService } from '../services/server-sent-events.service';
import { NotificationCenterService } from '../shared/layout/notification-center/notification-center.service';
import { BlogService } from '../../page/blog/blog.service';

export const provideInitializer = () => {
  return [
    ...parallelInitializer,
  ];
};

const parallelInitializer: EnvironmentProviders[] = createInitializerQueueList([
  {
    token: DataPreloaderService,
    initializerFn: (service: DataPreloaderService) => service.preloadCriticalData(),
  },
  {
    token: UserService,
    initializerFn: (service: UserService) => service.updateUserLang(),
  },
  {
    token: PwaService,
    initializerFn: (service: PwaService) => service.registerServiceWorker(),
  },
  {
    token: SeoService,
    initializerFn: (service: SeoService) => service.updateGlobalHeadLink(),
  },
  {
    token: GoogleTagManagerService,
    initializerFn: (service: GoogleTagManagerService) => service.addGtmToDom(),
  },
  {
    token: GlobalEventsService,
    initializerFn: (service: GlobalEventsService) => service.initGlobalEvent(),
  },
  {
    token: FullScreenService,
    initializerFn: (service: FullScreenService) => service.init(),
  },
  {
    token: RedirectorService,
    initializerFn: (service: RedirectorService) => service.detectNoCacheParameter(),
  },
  {
    token: ContentUpdaterService,
    initializerFn: (service: ContentUpdaterService) => service.runContentChangeHandler(),
  },
  {
    token: GameProvidersService,
    initializerFn: (service: GameProvidersService) => service.updateProviderListOnLangChange(),
  },
  {
    token: GameCategoryAttrService,
    initializerFn: (service: GameCategoryAttrService) => service.updateCategoryAttrListOnLangChange(),
  },
  {
    token: BankingService,
    initializerFn: (service: BankingService) => service.fetchPayments(),
  },
  {
    token: ZendeskChatService,
    initializerFn: (service: ZendeskChatService) => service.initChat(),
  },
  {
    token: EpmCountryRestrictionService,
    initializerFn: (service: EpmCountryRestrictionService) => service.showCookiesMessage(),
  },
  {
    token: UserRestrictionsService,
    initializerFn: (service: UserRestrictionsService) => service.initPlayerRestrictions(),
  },
  {
    token: ServerSentEventsService,
    initializerFn: (service: ServerSentEventsService) => service.initSseEvents(),
  },
  {
    token: NotificationCenterService,
    initializerFn: (service: NotificationCenterService) => service.listenSseNotifications(),
  },
  {
    token: BlogService,
    initializerFn: (service: BlogService) => {
      service.getBlogNotifications();
      service.getBlogBonuses();
    },
  },
]);
